module.exports = __webpack_public_path__ + "media/theme/sc_itunes-79e83d71.png";